import type { FaireProductEntity } from "../../entity_types/product";

export const p_3hpsbbsqvd: FaireProductEntity = {
  token: "p_3hpsbbsqvd",
  type: "product",
  name: '"Forever grateful" Mountain Sunshine Thank You Card',
  brandToken: "b_5nktagw2q1",
  brandName: "Big Moods",
  imageUrl:
    "https://cdn.faire.com/fastly/3fa5fdf39d854597af968461d2b903125c5c9e5fd27095b0b4a3124b23018731.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7f0307bdc24a8ab82a2df91a333cc9c490b322d12118766ab3a94869ece3ae40.webp",
    "https://cdn.faire.com/fastly/e41bfd211ae6155c982bde1e8bcb76a8537757d5e062f8282058f2d1a25ba37c.jpeg",
    "https://cdn.faire.com/fastly/193a9acd0d3134bb6f29f8ea03e1f2575ed00775e2fda3237a9f3c06413a9e2d.jpeg",
  ],
  priceDollars: 1.95,
  description:
    'Express your forever gratitude with this mountainscape and sunshine nature thank you greeting card that reads "forever grateful".\n\n-A2 Size (4.25 x 5.5 inches folded).\n-Printed on premium 16pt thick cardstock with a matte finish.\n-Paired with a coordinated kraft or holiday color envelope.\n-BLANK INSIDE\n-Hand Drawn\n\nCategories: card, cards, greeting card, greeting cards, thank you, thank you cards, appreciation, appreciation cards, thank you gifts, teacher thank you cards, mom thank you cards, wedding thank you cards, business thank you cards, mountainscape, mountains, nature.',
  tags: [],
  msrpDollars: 4.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:19.983Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
